import { useTheme, TypographyProps, Typography } from "@mui/material";

const BaseSelectItemTypo = (props: TypographyProps) => {
  return (
    <Typography
      variant="mobile-action-s"
      color="text.primary"
      sx={{ display: "flex", alignItems: "center", width: "100%", textAlign: "center", gap: "8px" }}
      {...props}>
      {props.children}
    </Typography>
  );
};

export default BaseSelectItemTypo;
